import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSidenavModule, MatButtonModule, MatToolbarModule, MatIconModule, MatListModule, MAT_HAMMER_OPTIONS } from '@angular/material';
import { RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import {Page1Component} from './page1/page1.component';
import {Page2Component} from './page2/page2.component';

import 'hammerjs';
import { HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';

  export class HammerConfig extends HammerGestureConfig {

  }

@NgModule({
  declarations: [
    AppComponent,
    Page1Component,
    Page2Component
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatSidenavModule,
    MatButtonModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    RouterModule.forRoot([
      {
        path: 'page1',
        component: Page1Component
      },
      {
        path: 'page2',
        component: Page2Component
      },
      {
        path: '',
        redirectTo: 'page1',
        pathMatch: 'full'

      },
      {
        path: '**',
        component: Page1Component
      }
    ]),

  ],
  providers: [{ 
    provide: HAMMER_GESTURE_CONFIG, 
    useClass: HammerConfig,
  }], // use our custom hammerjs config
  bootstrap: [AppComponent]
})
export class AppModule { }



